import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

export default class UserSearch extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.query = '';
    this.results = [];
    this.loading = false;
    this.onchange = this.attrs.onchange || (() => {});
    this.debounceTimeout = null;

    console.log(this.onchange);
  }

  search() {
    if (!this.query.trim()) {
      this.results = [];
      m.redraw();
      return;
    }

    this.loading = true;

    app.store.find('users', { filter: { q: this.query } })
      .then(users => {
        this.results = users;
        this.loading = false;
        m.redraw();
      });
  }

  debouncedSearch() {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => this.search(), 500);
  }

  selectUser(user) {
    this.query = '';
    this.results = [];
    this.onchange(user);
    m.redraw();
  }

  view() {
    return (
      <div className="UserSearch" role="search">
        <input
          className="FormControl"
          type="search"
          placeholder={this.attrs.placeholder || 'Search users...'}
          value={this.query}
          oninput={e => {
            this.query = e.target.value;
            this.debouncedSearch();
          }}
          onkeydown={e => {
            if (e.key === 'Enter' && this.results.length) {
              this.selectUser(this.results[0]);
            }
          }}
        />
        {this.loading && <LoadingIndicator />}
        {this.results.length > 0 && (
          <ul className="UserSearch-results">
            {this.results.map(user => (
              <li
                key={user.id()}
                className="UserSearch-result"
                tabindex={0}
                onclick={() => this.selectUser(user)}
                onkeydown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.selectUser(user);
                  }
                }}
              >
                {user.avatarUrl() ? (
                  <img src={user.avatarUrl()} alt={user.username()} className="UserSearch-avatar" />
                  ) : (
                    <span className="UserSearch-avatar" title={user.username()} style={{ background: user.color?.() || '#ccc' }}>
                      {user.username().charAt(0).toUpperCase()}
                    </span>
                  )
                }
                <span className="UserSearch-username">{user.username()}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}
